export class PhoneInterviewQuestionnaireCompetenceRateModel {
  competenceDictId: number;
  competenceRate: number;
  yearsOfExperience: number;
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/interviews/questionnaires/phone-interview-questionnaire/phone-interview-questionnaire-competence-rate.model.ts